export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
